<template>
  <div>
    <section class="content">
      <div class="col-md-12" style="padding: 0;">
        <div class="portlet light">
          <div class="portlet-title">
            <div class="caption pull-left">
              <div class="subject">
                <span class="caption-subject">Liste des récapitulatifs ABFT</span>
              </div>
              <div class="subsubject">
                Retrouvez la liste des récapitulatifs et des membres associés réceptionnés et traités par l'ABFT
              </div>
            </div>
          </div>
          <div class="portlet-body">
            <vue-simple-spinner
              :size="64"
              message="Chargement en cours..."
              :spacing="25"
              text-fg-color="#FFF"
              :font-size="16"
              v-if="loadingRequest"
            ></vue-simple-spinner>
            <div v-if="!loadingRequest">

              <b-table responsive bordered striped hover
                       :items="getClub.recaps"
                       :fields="columns"
                       :per-page="perPage"
                       empty-text="Données indisponibles"
                       :current-page="currentPage"
                       show-empty
              >
                <template v-slot:cell(actions)="row">
                  <!-- we use @click.stop here to prevent emitting of a 'data-clicked' event  -->
                  <button class="btn btn-primary btn-xs pull-right"
                          @click.stop="row.toggleDetails">{{ row.detailsShowing ? 'Cacher' : 'Afficher' }} les détails
                  </button>
                </template>

                <template v-slot:cell(date)="data">
                  {{ formatDate(data.item.date, 'YYYY-MM-DD', 'DD/MM/YYYY') }}
                </template>

                <template v-slot:cell(statut)="data">
                                <span
                                  :class="getClassName(data.item.statut)">
                                    {{ data.item.statut }}
                                </span>
                </template>

                <template v-slot:row-details="row">
                  <b-card>


                    <b-row class="mb-12">
                      <b-col sm="12" class="text-sm-right">
                        <u>Membres de ce récapitulatif:</u>
                      </b-col>
                      <b-col sm="12">
                        <ul style="list-style: space-counter !important;">
                          <li v-for="membre in row.item.membres">{{ membre }}</li>
                        </ul>
                      </b-col>
                      <b-col sm="12">
                        <button class="btn btn-primary btn-xs pull-right"
                                v-if="!generationEnCours"
                                @click.stop="downloadRecap(row.item.id)">
                          Télécharger le récapitulatif
                        </button>
                        <vue-simple-spinner
                          :size="16"
                          text-fg-color="#FFF"
                          :font-size="16"
                          class="pull-right"
                          v-if="generationEnCours"
                        ></vue-simple-spinner>
                      </b-col>
                    </b-row>
                  </b-card>
                </template>
              </b-table>
              <b-pagination size="md" :total-rows="getClub.recaps.length" v-model="currentPage" :per-page="perPage"></b-pagination>
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script type="text/babel">
import Auth from '@/auth'
import moment from 'moment/moment'
import {mapGetters, mapActions} from 'vuex'

var $ = require('jquery')
var _ = require('lodash')
var FileSaver = require('file-saver');
export default {
  data() {
    return {
      recapsQueried: [],
      generationEnCours:false,
      currentPage: 1,
      perPage: 20,
      loadingRequest: false,
      columns: [
        {
          label: 'Date',
          key: 'date',
          sortable: true,
        },
        {
          label: 'Numéro',
          key: 'id',
          sortable: true,
        },
        {
          label: 'Nombre de licences',
          key: 'nombre_licence',
          sortable: false,
        },
        {
          label: 'Statut',
          key: 'statut',
          sortable: true,
        },
        {
          label: 'Total',
          key: 'total',
          sortable: false,
        },
        {
          label: 'Actions',
          key: 'actions',
        },
      ],
    }
  },
  methods: {
    downloadRecap: function (id_recap) {
      let these = this
      this.generationEnCours = true
      return this.$http.post
      (
        process.env.API_URL + "getRecapitulatifForDownload",
        JSON.stringify({"id_club": these.getClub.id,'id_recap':id_recap}),
        {responseType: 'blob'}
      ).then(function (response) {
        these.generationEnCours = false
        var blob = new Blob([response.body], {type: "application/pdf;charset=utf-8"});
        FileSaver.saveAs(blob, "Attestation.pdf");
        return response.blob();
      }, (response) => {
        these.$noty.error("Le récapitulatif n'a pas pu être téléchargé")
        these.generationEnCours = false
      })
    },
    getClassName: function (statut) {
      switch (statut) {
        case 'En cours':
          return 'text-warning'
          break
        case 'En attente de décision':
          return 'text-warning'
          break
        case 'En attente':
          return 'text-warning'
          break
        case 'Annulé / Refusé':
          return 'text-danger'
          break
        case 'Cloturé / Validé':
          return 'text-green'
          break

        default:
          return ''
      }
    },
    formatDate: function (value, ftmIn, fmtOut) {
      if (value == null) return ''
      fmtOut = (typeof fmtOut == 'undefined') ? 'DD/MM/YYYY HH:mm' : fmtOut
      return moment(value, ftmIn).format(fmtOut)
    },
    currentYear: function () {
      return moment().year();
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
    })
  },
  components: {},
  computed: {
    ...mapGetters({
      getMember: 'getMember',
      getClub: 'getClub',
      getRoutes: 'getRoutes',
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Club/ClubListRecapitulatifs.vue